import React from 'react'
import {observer} from 'mobx-react-lite'
import {IconButton} from '@mui/material'
import {ColDef, ICellRendererParams} from 'ag-grid-community'
import {ExpandIcon} from '@oc/icons'
import {DataWithDetailInfo, ToggleExpandRowAction} from './OcAgGridWithRowDetail'

interface OcAgGridExpandCellRendererProps<T extends object> extends ICellRendererParams {
    data: DataWithDetailInfo<T>
    toggleExpandRow: ToggleExpandRowAction<T>
}

function _OcAgGridExpandCellRenderer<T extends object>(props: OcAgGridExpandCellRendererProps<T>) {
    const [expanded, setExpanded] = React.useState<boolean>(
        () => props.api.getRowNode(`${props.node.id}-detail`)?.data.expanded
    )

    const toggleExpand = React.useCallback(() => {
        props.toggleExpandRow(props.data, props.node.id as string, props.api)
        setExpanded(old => !old)
    }, [props])

    return (
        <IconButton onClick={toggleExpand}>
            <ExpandIcon rotate={expanded ? undefined : 'left'} />
        </IconButton>
    )
}
export const OcAgGridExpandCellRenderer = observer(_OcAgGridExpandCellRenderer)

export function createExpandColumnDef<T extends object>(toggleExpandRow: ToggleExpandRowAction<T>): ColDef {
    return {
        colId: 'expand',
        sortable: false,
        filter: false,
        cellRenderer: OcAgGridExpandCellRenderer,
        cellRendererParams: {
            toggleExpandRow
        },
        width: 50,
        suppressSizeToFit: true,
        cellStyle: {
            padding: 0
        }
    }
}
